import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.svg";
import mission1 from "../../images/causes/1.jpg";
import mission2 from "../../images/causes/2.jpg";
import mission3 from "../../images/causes/3.jpg";
import mission4 from "../../images/causes/7.jpg";
import mission5 from "../../images/causes/8.jpg";
import mission6 from "../../images/causes/12.jpg";
import mission7 from "../../images/causes/17.jpg";
import mission8 from "../../images/causes/15.jpg";
import mission9 from "../../images/causes/19.jpg";
import mission10 from "../../images/causes/21.png";

import "./MissionPage.css";
import { Link } from "react-router-dom";

const MissionPage = () => {
  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={"wpo-site-header-s5"} />
      <PageTitle pageTitle={"Cardiac Missions"} pagesub={"Mission"} />

      {/* Creative Hero Section with Gradient Overlay */}
      <section
        className="mission-hero section-padding position-relative"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative">
                <Link to="/mission/ethio-istanbul-campaign">
                  <img
                    src={mission5}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(-4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Link>
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    right: "10%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2026 Mission
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                <Link to="/mission/ethio-istanbul-campaign">
                  <h2 className=" fw-bold">
                    Addis Ababa, Ethiopia Cardiac Mission
                  </h2>
                </Link>
                <h4 className="mb-4">
                  Italian medical team with Ethio-Istanbul General Hospital
                </h4>

                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
                 This mission focuses on eliminating the pediatric cardiac backlog through a historic partnership. By utilizing Ethio-Istanbul General Hospital as a specialized hub, life-saving, high-precision heart surgeries are delivered through a collaboration between the hospital's clinical team and volunteer Italian specialists. Supported by Heart to Heart’s logistics and financial aid, children receive world-class care entirely free of charge. 

                </p>
                <Link
                  to="/mission/ethio-istanbul-campaign"
                  className="mt-2 fw-bold"
                  style={{ color: "#066897" }}
                >
                  Read More <i className="fas fa-arrow-right"></i>
                </Link>
                <div className="mission-highlights mb-4">
                  {/* <div className="row g-3">
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-heart text-danger fs-2 mb-2"></i>
                        <h6>Screening</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-user text-primary fs-2 mb-2"></i>
                        <h6>Training</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-home text-success fs-2 mb-2"></i>
                        <h6>Support</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
                {/* <div className="mission-actions d-flex flex-wrap gap-3">
                  <a href="/donate" className="btn btn-light btn-lg px-4 py-3 fw-bold">Donate Now</a>
                  <a href="/contact" className="btn btn-outline-light btn-lg px-4 py-3">Get Involved</a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="mission-hero section-padding position-relative bg-light"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center reverse-mobile">
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                <Link to="/mission/campaign-ethio-istanbul-italy">
                  <h2 className="fw-bold" style={{}}>
                    Jigjiga, Ethiopia Cardiac Mission 
                  </h2>
                </Link>
                <h4 className="mb-4">
                  Italian medical team with Ethio-Istanbul General Hospital
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
This mission brings life-saving cardiac care to the Somali Regional State through a powerful partnership. By establishing a specialized surgical hub at Sheik Hassen Yebere Referral Hospital, high-precision heart surgeries are delivered through the joint collaboration of Ethio-Istanbul General Hospital’s medical team and volunteer Italian specialists. Supported by Heart to Heart’s logistics and financial aid, vulnerable children receive world-class care entirely free of charge. 
                </p>
                <Link
                  to="/mission/campaign-ethio-istanbul-italy"
                  className="mt-2 fw-bold"
                  style={{ color: "#066897" }}
                >
                  Read More <i className="fas fa-arrow-right"></i>
                </Link>
                <div className="mission-highlights mb-4">
                  {/* <div className="row g-3">
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-heart text-danger fs-2 mb-2"></i>
                        <h6>Screening</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-user text-primary fs-2 mb-2"></i>
                        <h6>Training</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-home text-success fs-2 mb-2"></i>
                        <h6>Support</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative ms-5">
                <Link to="/mission/campaign-ethio-istanbul-italy">
                  <img
                    src={mission4}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Link>
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    left: "-5%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2026 Mission
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section
        className="mission-hero section-padding position-relative"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative">
                <Link to="/mission/campaign-jigjiga">
                  <img
                    src={mission1}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(-4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Link>
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    right: "10%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2026 Mission
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                <Link to="/mission/campaign-jigjiga">
                  <h2 className=" fw-bold">Jigjiga Cardiac Mission </h2>
                </Link>
                <h4 className="mb-4">
                  By Ethio-Istanbul General Hospital Medical Team
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
                  Life-Saving Heart Surgery for Children This targeted mission
                  is a vital collaboration between the Ministry of Health, Heart
                  to Heart Children’s Aid, and international specialists to
                  bring life-saving cardiac care to the Somali Regional State.
                  By establishing a surgical hub at Sheik Hassen Yebere
                  Hospital, we are ensuring that children in Jigjiga receive
                  free, high-precision heart surgeries without the need to
                  travel to the capital.{" "}
                </p>

                <Link
                  to="/mission/campaign-jigjiga"
                  className="mt-2 fw-bold"
                  style={{ color: "#066897" }}
                >
                  Read More <i className="fas fa-arrow-right"></i>
                </Link>
                <div className="mission-highlights mb-4">
                
                </div>
             
              </div>
            </div>
          </div>
        </div>
      </section> */}

       <section
        className="mission-hero section-padding position-relative"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative">
                <Link to="/mission/campaign-gondar">
                  <img
                    src={mission10}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(-4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Link>
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    right: "10%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2026 Mission
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                <Link to="/mission/campaign-gondar">
                  <h2 className=" fw-bold">
                    Gondar, Ethiopia Cardiac Mission{" "}
                  </h2>
                </Link>
                <h4 className="mb-4">
                 Italian specialists team with  Ethio-Istanbul General Hospital.
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
                  The initiative focuses on saving children suffering from
                  severe heart disease by providing advanced, free cardiac
                  surgeries in Ethiopia. By delivering life-saving treatment to
                  23 vulnerable children, this mission directly supports
                  affected families and fosters knowledge sharing between
                  international specialists and local medical professionals,
                  giving every child the opportunity to grow, thrive, and live a
                  healthy life.
                </p>

                <Link
                  to="/mission/campaign-gondar"
                  className="mt-2 fw-bold"
                  style={{ color: "#066897" }}
                >
                  Read More <i className="fas fa-arrow-right"></i>
                </Link>
                <div className="mission-highlights mb-4">
                  {/* <div className="row g-3">
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-heart text-danger fs-2 mb-2"></i>
                        <h6>Screening</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-user text-primary fs-2 mb-2"></i>
                        <h6>Training</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-home text-success fs-2 mb-2"></i>
                        <h6>Support</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
                {/* <div className="mission-actions d-flex flex-wrap gap-3">
                  <a href="/donate" className="btn btn-light btn-lg px-4 py-3 fw-bold">Donate Now</a>
                  <a href="/contact" className="btn btn-outline-light btn-lg px-4 py-3">Get Involved</a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="mission-hero section-padding position-relative bg-light"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center reverse-mobile">
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                <Link to="/mission/campaign-jimma">
                  <h2 className="fw-bold" style={{}}>
                    Jimma, Ethiopia Cardiac Mission{" "}
                  </h2>
                </Link>
                <h4 className="mb-4">
                  By Ethio-Istanbul General Hospital
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
This initiative focuses on providing free, advanced pediatric cardiac surgeries in Ethiopia, saving 13 vulnerable children. For this regional campaign, Jimma University Medical Center provided the clinical space and facilities, while the surgical interventions were delivered by Ethio-Istanbul General Hospital. Supported by Heart to Heart’s logistics and financial aid, these children received life-saving care entirely free of charge. 
                </p>
                <Link
                  to="/mission/campaign-jimma"
                  className="mt-2 fw-bold"
                  style={{ color: "#066897" }}
                >
                  Read More <i className="fas fa-arrow-right"></i>
                </Link>
                <div className="mission-highlights mb-4">
                  {/* <div className="row g-3">
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-heart text-danger fs-2 mb-2"></i>
                        <h6>Screening</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-user text-primary fs-2 mb-2"></i>
                        <h6>Training</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-home text-success fs-2 mb-2"></i>
                        <h6>Support</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative ms-5">
                <Link to="/mission/campaign-jimma">
                  <img
                    src={mission6}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Link>
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    left: "-5%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2026 Mission
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     
 <section
        className="mission-hero section-padding position-relative"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative">
                {/* <Link to="/mission/campaign-jigjiga"> */}
                  <img
                    src={mission8}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(-4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                {/* </Link> */}
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    right: "10%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2026 Mission
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                {/* <Link to="/mission/campaign-jigjiga" > */}
                <h2 className=" fw-bold">
                  Tikur Anbessa, Addis Ababa Cardiac Mission
                </h2>

                {/* </Link> */}
                <h4 className="mb-4">
                  Free Pediatric Cardiac Surgeries at Tikur Anbessa Specialized Hospital 
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
This initiative provides free, advanced pediatric cardiac surgeries in Ethiopia, saving 30 vulnerable children. While all operations were performed entirely by Tikur Anbessa Specialized Hospital’s internal medical team and resident doctors, Heart to Heart Children’s Aid drove the mission's success by fully managing logistics and providing all necessary medical facilities, specialized equipment, and surgical supplies. 
                </p>

                {/* <Link to="/mission/campaign-gondar" className="mt-2 fw-bold" style={{color:'#066897'}}>
                                      Read More <i className="fas fa-arrow-right"></i>
                                    </Link> */}
                <div className="mission-highlights mb-4">
                  {/* <div className="row g-3">
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-heart text-danger fs-2 mb-2"></i>
                        <h6>Screening</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-user text-primary fs-2 mb-2"></i>
                        <h6>Training</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-home text-success fs-2 mb-2"></i>
                        <h6>Support</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
                {/* <div className="mission-actions d-flex flex-wrap gap-3">
                  <a href="/donate" className="btn btn-light btn-lg px-4 py-3 fw-bold">Donate Now</a>
                  <a href="/contact" className="btn btn-outline-light btn-lg px-4 py-3">Get Involved</a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="mission-hero section-padding position-relative bg-light"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center reverse-mobile">
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                {/* <Link to="/mission/campaign-ethio-istanbul-italy" > */}

                <h2 className="fw-bold" style={{}}>
                  St. Paul’s, Addis Ababa Cardiac Mission{" "}
                </h2>
                {/* </Link> */}
                <h4 className="mb-4">
Free Pediatric Cardiac Surgeries at St. Paul’s Hospital Millennium Medical College 
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
  This campaign focuses on delivering free, specialized cardiac care to rescue 15 vulnerable children in Ethiopia. Heart to Heart Children’s Aid fully sponsored the initiative by procuring all essential clinical resources and equipping the operating theaters. This dedicated support empowered St. Paul’s Hospital’s internal pediatric surgical team and resident doctors to seamlessly perform every life-saving operation. 
                </p>
                {/* <Link to="/mission/campaign-ethio-istanbul-italy" className="mt-2 fw-bold" style={{color:'#066897'}}>
                                      Read More <i className="fas fa-arrow-right"></i>
                                    </Link> */}
                <div className="mission-highlights mb-4">
                  {/* <div className="row g-3">
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-heart text-danger fs-2 mb-2"></i>
                        <h6>Screening</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-user text-primary fs-2 mb-2"></i>
                        <h6>Training</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-home text-success fs-2 mb-2"></i>
                        <h6>Support</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative ms-5">
                {/* <Link to="/mission/campaign-ethio-istanbul-italy"> */}
                  <img
                    src={mission7}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                {/* </Link> */}
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    left: "-5%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2026 Mission
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      <section
        className="mission-hero section-padding position-relative bg-light"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center reverse-mobile">
             <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative ms-5">
                {/* <Link to="/mission/campaign-ethio-istanbul-italy"> */}
                  <img
                    src={mission9}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                {/* </Link> */}
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    left: "-5%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2026 Mission
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                {/* <Link to="/mission/campaign-ethio-istanbul-italy" > */}

                <h2 className="fw-bold" style={{}}>
                  Cardiac Center - Ethiopian Cardiac Mission
                </h2>
                {/* </Link> */}
                <h4 className="mb-4">
                 Free Pediatric Cardiac Surgeries at The Cardiac Center Ethiopia (Lib Makel) 
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
Centered on rescuing 30 vulnerable children with severe heart disease, this initiative expands critical healthcare access across Ethiopia. Heart to Heart Children’s Aid managed the entire foundational groundwork and logistical facility demands, serving as an essential anchor. This strategic coordination cleared the path for The Cardiac Center Ethiopia’s resident doctors and internal medical staff to dedicatedly perform every life-saving surgery.                 </p>
                {/* <Link to="/mission/campaign-ethio-istanbul-italy" className="mt-2 fw-bold" style={{color:'#066897'}}>
                                      Read More <i className="fas fa-arrow-right"></i>
                                    </Link> */}
                <div className="mission-highlights mb-4">
                  {/* <div className="row g-3">
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-heart text-danger fs-2 mb-2"></i>
                        <h6>Screening</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-user text-primary fs-2 mb-2"></i>
                        <h6>Training</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-home text-success fs-2 mb-2"></i>
                        <h6>Support</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </section>

      <section
        className="mission-hero section-padding position-relative bg-light"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center reverse-mobile">
            
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                <Link to="/mission/new-year-2025">
                  <h2 className="fw-bold" style={{}}>
                    Ethiopian New Year 2018 Cardiac Mission{" "}
                  </h2>
                </Link>
                <h4 className="mb-4">
                  Free cardiac surgery at Ethio-Istanbul General Hospital
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
                  Given this aim, the initiative focuses on saving children
                  suffering from heart disease by providing free cardiac
                  surgeries in Ethiopia. It ensures access to life-saving
                  treatment, supports affected families, and raises awareness,
                  giving every child the opportunity to grow, thrive, and live a
                  healthy life.{" "}
                </p>

                <Link
                  to="/mission/new-year-2025"
                  className="mt-2 fw-bold"
                  style={{ color: "#066897" }}
                >
                  Read More <i className="fas fa-arrow-right"></i>
                </Link>
                <div className="mission-highlights mb-4"></div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative ms-5">
                <Link to="/mission/new-year-2025">
                  <img
                    src={mission3}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Link>
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    left: "-5%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2025 Mission
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="mission-hero section-padding position-relative "
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-6">
              <div className="mission-hero-image mb-4 mb-lg-0 position-relative">
                <Link to="/mission/new-year-2024">
                  <img
                    src={mission2}
                    alt="Mission Zambia"
                    className="img-fluid rounded-4 shadow-lg"
                    style={{
                      transform: "rotate(-4deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Link>
                <div
                  className="floating-badge position-absolute"
                  style={{
                    top: "10%",
                    right: "10%",
                    background: "#ff6b6b",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
                  }}
                >
                  2024 Mission
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mission-hero-text text-white">
                <Link to="/mission/new-year-2024">
                  <h2 className=" fw-bold" style={{}}>
                    Ethiopian New Year 2017 Cardiac Mission{" "}
                  </h2>
                </Link>
                <h4 className="mb-4">
                  Free cardiac surgery at Ethio-Istanbul General Hospital
                </h4>
                <p
                  className="lead mb-4"
                  style={{ fontSize: "1.2rem", lineHeight: "1.6" }}
                >
                  The Heart to Heart Foundation successfully provided free heart
                  surgeries to 32 children this past year, allowing them to
                  welcome the Ethiopian New Year in full health. This milestone
                  celebrates lives saved while serving as a vital call to action
                  for the 16,000+ children still waiting. Through collective
                  support, we are ensuring our nation’s successors grow up
                  strong.
                </p>

                <Link
                  to="/mission/new-year-2024"
                  className="mt-2 fw-bold"
                  style={{ color: "#066897" }}
                >
                  Read More <i className="fas fa-arrow-right"></i>
                </Link>
                <div className="mission-highlights mb-4">
                  {/* <div className="row g-3">
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-heart text-danger fs-2 mb-2"></i>
                        <h6>Screening</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-user text-primary fs-2 mb-2"></i>
                        <h6>Training</h6>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="highlight-card text-center p-3 bg-white bg-opacity-10 rounded-3">
                        <i className="ti-home text-success fs-2 mb-2"></i>
                        <h6>Support</h6>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </section>

      {/* Creative CTA with Parallax Effect */}
      <section
        className="mission-cta section-padding position-relative overflow-hidden bg-light"
        style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: "white",
        }}
      >
        <div className="container">
          <div className="cta-content text-center position-relative z-1">
            <h2 className="display-4 fw-bold mb-4">Join the Next Mission</h2>
            <p className="lead mb-5" style={{ fontSize: "1.3rem" }}>
              Your support helps us reach the next community, train local staff,
              and cover urgent surgical care for more children in need.
            </p>
            <div className="cta-buttons d-flex justify-content-center gap-4 flex-wrap">
              <a
                href="/donate"
                className="btn btn-light btn-xl px-5 py-3 fw-bold shadow-lg"
              >
                <i className="ti-heart me-2"></i>Support the Mission
              </a>
              {/* <a href="/contact" className="btn btn-outline-light btn-xl px-5 py-3 fw-bold">
                <i className="ti-email me-2"></i>Get Involved
              </a> */}
            </div>
          </div>
        </div>
        {/* Background Pattern */}
        {/* <div className="cta-bg-pattern position-absolute top-0 start-0 w-100 h-100 opacity-10">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="hearts" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse">
                <path d="M25 40 Q 20 35, 15 30 Q 10 25, 15 20 Q 20 15, 25 20 Q 30 15, 35 20 Q 40 25, 35 30 Q 30 35, 25 40 Z" fill="white"/>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#hearts)"/>
          </svg>
        </div> */}
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default MissionPage;
